<template>
    <div>
        <nav class="navbar" role="navigation" aria-label="main navigation">
            <div class="navbar-brand">
                <a class="navbar-item">
                    <h4>logan's Barbershop</h4>
                </a>

                <a role="button" class="navbar-burger" aria-label="menu" aria-expanded="false" v-on:click="showNav = !showNav" v-bind:class="{ 'is-active' : showNav }">
                    <span aria-hidden="true"></span>
                    <span aria-hidden="true"></span>
                    <span aria-hidden="true"></span>
                </a>
            </div>
            <div class="navbar-menu" v-bind:class="{ 'is-active' : showNav }">
                <div class="navbar-end">
                    <a href="#location" class="navbar-item">
                        Location
                    </a>

                    <a href="#prices" class="navbar-item">
                        Prices
                    </a>

                    <a href="#times" class="navbar-item">
                        Opening Times
                    </a>
                </div>
            </div>
        </nav>
    </div>
</template>
<script>
    export default {
        name: 'nav-bar',
        data() {
            return {
                showNav: false
            }
        }
    }

</script>
<style scoped>
    @import url('https://fonts.googleapis.com/css?family=Major+Mono+Display');

    h4 {
        font-family: 'Major Mono Display', monospace;
        ;
        font-weight: 300;
        font-size: 1.5rem;

    }

    @media only screen and (max-width: 425px) {

        h4 {
            font-size: 1.2rem;
        }
    }

</style>
